// Пресеты @uppy/image-editor: поворот и кадрирование перед отправкой.
//
// Редактор работает только без автозагрузки (autoProceed: false) — иначе файл уходит в
// S3 через миллисекунды после выбора и править уже нечего. Поэтому он стоит лишь там,
// где файлов мало: документы клиента и аватары. Фото выдачи и приёма — пачки до 30
// снимков, там автозагрузка важнее (решение USER 2026-10-03).
//
// Редактор пересохраняет кадр (canvas.toBlob с исходным типом), а компрессор после него
// жмёт ещё раз. Его собственное quality по умолчанию — 0.8.

// Документы клиента идут на распознавание (OCR): двойное сжатие 0.8 → 0.85 садит
// артефакты на контуры букв. Редактор сохраняет почти без потерь, итог задаёт компрессор.
export const IMAGE_EDITOR_DOCUMENT = {
  quality: 0.95,
};

// Аватар сотрудника показывается кругом — кадр строго квадратный, широкие форматы убраны.
export const IMAGE_EDITOR_SQUARE = {
  cropperOptions: {
    viewMode: 0,
    background: false,
    autoCropArea: 1,
    responsive: true,
    aspectRatio: 1,
  },
  actions: {
    revert: true,
    rotate: true,
    granularRotate: true,
    flip: true,
    zoomIn: true,
    zoomOut: true,
    cropSquare: true,
    cropWidescreen: false,
    cropWidescreenVertical: false,
  },
};

// Аватар машины показывается и кругом, и в прямоугольных карточках — пропорции не навязываем.
export const IMAGE_EDITOR_FREE = {};

// Встроенный Dashboard бывает низким (документы клиента — 250px в ClientCard), и редактор
// в нём тесен: панель инструментов ложится на картинку. Пока редактор открыт, Dashboard
// выше; после сохранения или отмены — прежняя высота. Модальному Dashboard (аватары)
// не нужно: его размер задаёт окно, а не опция height.
export const EDITING_HEIGHT = 550;

/**
 * @param {object} uppy инстанс @uppy/core с установленными Dashboard и ImageEditor
 * @param {number|string} height обычная высота Dashboard — та же, что в .use(Dashboard)
 */
export function growWhileEditing(uppy, height) {
  const setHeight = (value) => {
    const dashboard = uppy.getPlugin("Dashboard");
    if (dashboard) dashboard.setOptions({ height: value });
  };

  uppy.on("file-editor:start", () => setHeight(EDITING_HEIGHT));
  uppy.on("file-editor:complete", () => setHeight(height));
  uppy.on("file-editor:cancel", () => setHeight(height));
}
